import styled from '@emotion/styled';
import { Button } from 'antd';

// eslint-disable-next-line import/prefer-default-export
export const LinkButton = styled(Button)`
  padding: 0;
`;
